import { render, staticRenderFns } from "./providers.vue?vue&type=template&id=5ee96588&scoped=true&"
import script from "./providers.vue?vue&type=script&lang=js&"
export * from "./providers.vue?vue&type=script&lang=js&"
import style0 from "./providers.vue?vue&type=style&index=0&id=5ee96588&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee96588",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CFlex: require('@chakra-ui/vue').CFlex, CBox: require('@chakra-ui/vue').CBox})
